"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getArrowPath = exports.getArrowCoordinates = void 0;
const constants_1 = require("../../constants");
const utility_arrow_1 = require("./utility.arrow");
const utility_paths_1 = require("../utility.paths");
function getDoubleHeadedArrowCoordinates(width, height, tailWidth, headWidth) {
    const coordinates = [];
    const heightBy2 = height / 2;
    const widthBy2 = tailWidth / 2;
    coordinates.push({ x: 0, y: heightBy2 });
    coordinates.push({
        x: headWidth,
        y: 0,
    });
    coordinates.push({
        x: headWidth,
        y: heightBy2 - widthBy2,
    });
    coordinates.push({
        x: width - headWidth,
        y: heightBy2 - widthBy2,
    });
    coordinates.push({
        x: width - headWidth,
        y: 0,
    });
    coordinates.push({ x: width, y: heightBy2 });
    coordinates.push({
        x: width - headWidth,
        y: height,
    });
    coordinates.push({
        x: width - headWidth,
        y: heightBy2 + widthBy2,
    });
    coordinates.push({
        x: headWidth,
        y: heightBy2 + widthBy2,
    });
    coordinates.push({
        x: headWidth,
        y: height,
    });
    return coordinates;
}
function getSingleHeadedArrowCoordinates(width, height, tailWidth, headWidth) {
    const coordinates = [];
    const heightBy2 = height / 2;
    const widthBy2 = tailWidth / 2;
    // Arrow tail top staring point
    coordinates.push({
        x: 0,
        y: heightBy2 - widthBy2,
    });
    // Arrow tail top end point
    coordinates.push({
        x: width - headWidth,
        y: heightBy2 - widthBy2,
    });
    // Arrow head vertical Top end point
    coordinates.push({
        x: width - headWidth,
        y: 0,
    });
    // Arrow head right tip point
    coordinates.push({ x: width, y: heightBy2 });
    // Arrow head vertical bottom end point
    coordinates.push({
        x: width - headWidth,
        y: height,
    });
    // Arrow  tail bottom end point
    coordinates.push({
        x: width - headWidth,
        y: heightBy2 + widthBy2,
    });
    // Arrow tail bottom start point
    coordinates.push({
        x: 0,
        y: heightBy2 + widthBy2,
    });
    return coordinates;
}
function getArrowCoordinates(width, height, tailWidth, headWidth, numberOfArrowHeads) {
    if (numberOfArrowHeads === 2) {
        return getDoubleHeadedArrowCoordinates(width, height, tailWidth, headWidth);
    }
    return getSingleHeadedArrowCoordinates(width, height, tailWidth, headWidth);
}
exports.getArrowCoordinates = getArrowCoordinates;
function getArrowPath(arrowShape, numberOfArrowHeads) {
    const width = constants_1.SvgDefaults.viewBoxWidth;
    const height = constants_1.SvgDefaults.viewBoxHeight;
    const { arrowTailWidth, arrowHeadLength } = utility_arrow_1.getArrowDimensions(arrowShape, width, height, numberOfArrowHeads || 1);
    const coordinates = getArrowCoordinates(width, height, arrowTailWidth, arrowHeadLength, numberOfArrowHeads || 1);
    return utility_paths_1.generatePathFromCoordinates(coordinates);
}
exports.getArrowPath = getArrowPath;
//# sourceMappingURL=arrow.js.map